import { render } from "./DosagemPage.vue?vue&type=template&id=483d9cdc"
import script from "./DosagemPage.vue?vue&type=script&lang=js"
export * from "./DosagemPage.vue?vue&type=script&lang=js"

import "./DosagemPage.vue?vue&type=style&index=0&id=483d9cdc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__